import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { dsClass } from '../../../../common/constants/dsClasses';
import { confirmOrderMsg, nextMsg, previousMsg, t } from '../../../../common/i18n';

import './StepButtons.scss';

export interface StepSubmitButtonsProps {
  onPrevious?: () => void;
  onNext?: () => void;
  onSubmit?: () => void;
  disableForward?: boolean;
}

export const StepButtons = ({ onPrevious, onNext, onSubmit, disableForward = false }: StepSubmitButtonsProps) => {
  return (
    <div
      className={classNames(
        dsClass.MARGIN_TOP_4,
        dsClass.DISPLAY_FLEX,
        dsClass.JUSTIFY_CONTENT_SPACE_BETWEEN,
        dsClass.ALIGN_ITEMS_CENTER
      )}
    >
      {onPrevious && (
        <CL.Button
          onClick={onPrevious}
          iconPosition="left"
          icon={<CL.Icon icon="arrow-left" type="filled" className="of-step-buttons__icon--left" />}
          color="link"
        >
          {t.CACI(previousMsg)}
        </CL.Button>
      )}
      {onNext && (
        <CL.Button
          onClick={onNext}
          disabled={disableForward}
          iconPosition="right"
          icon={<CL.Icon icon="arrow-right" type="filled" className="of-step-buttons__icon--right" />}
          className={classNames(onPrevious && 'of-step-buttons__button--right')}
        >
          {t.F0MY(nextMsg)}
        </CL.Button>
      )}
      {onSubmit && (
        <CL.Button
          onClick={onSubmit}
          disabled={disableForward}
          className={classNames(onPrevious && 'of-step-buttons__button--right')}
        >
          {t.RZU4(confirmOrderMsg)}
        </CL.Button>
      )}
    </div>
  );
};
